import { alterDate } from '@hc-frontend/utils'

function lastDateForBTM({ sDate, period, policies, dob }) {
  const policyEndDate = alterDate({ date: sDate, days: period * policies - 1 })
  const dob65Date = alterDate({
    date: dob,
    years: 65,
    days: -1
  })

  return dob65Date < policyEndDate ? dob65Date : policyEndDate
}

export default lastDateForBTM
